import PlacementImg from '@/modules/ReferAFriendPage/assets/Placement.png';
import ReferImg from '@/modules/ReferAFriendPage/assets/Refer.png';
import RewardImg from '@/modules/ReferAFriendPage/assets/Reward.png';
import {
  ReferFriendStep,
  ReferFriendStepProps,
} from '@/modules/ReferAFriendPage/components/ReferFriendStep/ReferFriendStep';
import { useMemo } from 'react';

import styles from './ReferFriendRules.module.scss';

interface ReferFriendRulesProps {
  referralAmount: string;
}

export const ReferFriendRules = ({ referralAmount }: ReferFriendRulesProps) => {
  const referFriendSteps: ReferFriendStepProps[] = useMemo(
    () => [
      {
        imageSrc: ReferImg.src,
        stepNumber: 1,
        description:
          'Sign in or register with Medrecruit to make your referral. You can refer as many friends as you like. Being signed in helps us keep your data secure.',
      },
      {
        imageSrc: PlacementImg.src,
        stepNumber: 2,
        description:
          'Your friend will receive an email with your unique referral link. Once they register and complete their first placement, your reward will be activated.',
      },
      {
        imageSrc: RewardImg.src,
        stepNumber: 3,
        description: `Earn between $100-${referralAmount}*. The amount depends on how many days your friend works on their first placement. To receive the full $1000, they must complete 25+ shifts within 6 weeks (within 12 months of referral).`,
      },
    ],
    [referralAmount],
  );
  return (
    <div className={styles.referFriendRules}>
      <div className={styles.rulesContent}>
        <h2 className={styles.title}>How our friend referral works</h2>
        <div className={styles.steps}>
          {referFriendSteps.map(step => (
            <ReferFriendStep key={step.stepNumber} {...step} />
          ))}
        </div>
      </div>
    </div>
  );
};
